import React, { useState, useEffect } from "react";
import "./App.css";
import axios from "axios";
import LevelGrid from "./components/LevelGrid";
import VideoPlayer from "./components/VideoPlayer";

function App() {
  const [levels, setLevels] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);

  useEffect(() => {
    // Fetch levels from the backend
    axios
      .get("https://boulder.hoope.me/api.php?endpoint=levels")
      .then((response) => setLevels(response.data))
      .catch((error) => console.error(error));
  }, []);

  const handleLevelClick = (level) => {
    setSelectedVideo(level.video_path);
    setSelectedLevel(level.level_name);
  };

  return (
    <div
      style={{ textAlign: "center", backgroundColor: "#000", color: "#fff" }}
    >
      <h1>Boulder Levels</h1>
      <LevelGrid
        levels={levels}
        selectedLevel={selectedLevel}
        onLevelClick={handleLevelClick}
      />
      {selectedVideo && <VideoPlayer videoPath={selectedVideo} />}
    </div>
  );
}

export default App;
